import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setCategories, setLoading } from "../../repository/slice";

function* getCategoriesWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/admin/category/get-list", payload);
        if (isError) {

        } else {
            yield put(setCategories({ categories: data, count: data.length }));
        }
    } catch (error) {
        console.error("getCategoriesWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getCategoriesWatcher() {
    yield takeLatest("@saga/GET_CATEGORIES", getCategoriesWorker);
};
